export const cidade = 'cidades'
export const regiao = 'regioes'
export const estado = 'estados'
export const usuario = 'usuarios'
export const tecnico = 'tecnicos'
export const cliente = 'clientes'
export const industria = 'industrias'
export const telefone = 'telefones'
export const email = 'emails'
export const emailDaIndustria = 'emails/industria'
export const telefoneDoCliente = 'telefones/cliente'
export const telefoneDaIndustria = 'telefones/industria'
export const telefoneDoTecnico = 'telefones/tecnico'
export const telefoneDoResponsavel = 'telefones/responsavel'
export const contrato = 'contratos'
export const visita = 'visitas'
export const balancete = 'balancetes'
export const laudo = 'laudos'
export const relatorio = 'relatorios'
export const responsavel = 'responsaveis'
export const pendencia = 'pendencias'
export const vinculos = 'vinculos'
export const eventos = 'eventos'
export default 'auth'
